import { useEffect, useLayoutEffect } from 'react';
import { isBrowser } from '../utils';
// React currently throws a warning when using useLayoutEffect on the platform.
// To get around it, we can conditionally useEffect on the platform (no-op) and
// useLayoutEffect in the browser.
export const useIsomorphicLayoutEffect = isBrowser() ? useLayoutEffect : useEffect;